import React, { Fragment, useEffect, useRef, useState } from 'react'
import '../../Styles/SettingsContainer.css'
import CustomSearchField from 'src/Common/ui/searchInput'
import { IoMdHelpCircleOutline, IoMdNotificationsOutline, IoMdPerson } from 'react-icons/io'
import { FaChevronRight } from 'react-icons/fa6'
import { cn } from 'src/lib/utils'
import { MdHistory, MdManageAccounts, MdOutlineAppSettingsAlt } from 'react-icons/md'
import { AiOutlineTool } from 'react-icons/ai'
import { useNavigate } from 'react-router'
import * as RoutePaths from '../../Entities/RoutePath'
import ProfileContainer from '../SettingsContainer/Profile/ProfileContainer'
import { useSettingsStore } from './Store/Store'
import * as MainContainerEntity from '../../Entities/MainContainerTypes'
import General from './General/General'
import { GoShieldLock } from 'react-icons/go'
import { TbPlugConnected } from 'react-icons/tb'
import { ConfigurationsContainer } from './Configurations/ConfigurationsContainer'

const SettingsContainer = () => {
    const navigate = useNavigate()
    const [ search, setSearch ] = useState('')
    const [ selectedNav, setselectedNav ] = useState('profile')

    const settingsList = [
        { icon: <IoMdPerson className='mr-[20px]' />, navLink: 'profile', visible: true, title: 'Profile', rightNavIcon: <FaChevronRight /> },
        { icon: <MdOutlineAppSettingsAlt className='mr-[20px]' />, navLink: 'general', visible: true, title: 'General', rightNavIcon: <FaChevronRight /> },
        { icon: <MdManageAccounts className='mr-[20px]' />, navLink: 'userManagement', visible: true, title: 'User Management', rightNavIcon: <FaChevronRight /> },
        { icon: <AiOutlineTool className='mr-[20px]' />, navLink: 'configuration', visible: true, title: 'Configuration', rightNavIcon: <FaChevronRight /> },
        { icon: <IoMdNotificationsOutline className='mr-[20px]' />, navLink: 'notification', visible: false, title: 'Notification', rightNavIcon: <FaChevronRight /> },
        { icon: <GoShieldLock className='mr-[20px]' />, navLink: 'accountSecurity', visible: false, title: 'Account & Security', rightNavIcon: <FaChevronRight /> },
        { icon: <MdHistory className='mr-[20px]' />, navLink: 'activitySecurity', visible: false, title: 'Activity & History\'s', rightNavIcon: <FaChevronRight /> },
        { icon: <TbPlugConnected className='mr-[20px]' />, navLink: 'apiAccess', visible: false, title: 'API Access', rightNavIcon: <FaChevronRight /> },
        { icon: <IoMdHelpCircleOutline className='lg:w-8 lg:h-8 xl:w-6 xl:h-6 mr-[20px]' />, navLink: 'help-center', visible: true, title: 'Help Center', rightNavIcon: <FaChevronRight /> }
    ]

    const userManagementData = [
        { title: 'User List', rightNavIcon: <FaChevronRight color='hsl(var(--primary))' />, navLink: 'userList' },
        { title: 'Roles and Permission', rightNavIcon: <FaChevronRight color='hsl(var(--primary))' />, navLink: 'userManagement' }
    ]
    const { getApplicationSettings, getConfigurationBasedOrganization } = useSettingsStore()
    const orgId = localStorage.getItem('orgId')
    useEffect(() => {
        getApplicationSettings()
        getConfigurationBasedOrganization(orgId)
    }, [])
    const handleSettingSubOptions = (items) => {
        if (items?.navLink === 'userList') {
            navigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.SETTINGS.URI + RoutePaths.USER_MANAGEMENT.URI + RoutePaths.USER_LIST.URI)
        } else if (items?.navLink === 'userManagement') {
            navigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.SETTINGS.URI + RoutePaths.USER_MANAGEMENT.URI + RoutePaths.ROLES_PERMISSION.URI + '?roleStatus=1')
        }
        // if (items.name === 'HeatMap') {
        //     customNavigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.SETTINGS.URI + RoutePaths.HEAT_MAP.URI, <div>{RoutePaths.HEAT_MAP.NAME}</div>)
        // } else if (items.name === 'Indicator') {
        //     customNavigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.SETTINGS.URI + RoutePaths.INDICATORS.URI, <div>{RoutePaths.INDICATORS.NAME}</div>)
        // } else if (items.name === 'Roles and Permission') {
        //     customNavigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.SETTINGS.URI + RoutePaths.USER_MANAGEMENT.URI + RoutePaths.ROLES_PERMISSION.URI, <div>{RoutePaths.USER_MANAGEMENT.NAME}</div>)
        // } else if (items.name === 'User List') {
        //     customNavigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.SETTINGS.URI + RoutePaths.USER_MANAGEMENT.URI + RoutePaths.USER_LIST.URI, <div>{RoutePaths.USER_MANAGEMENT.NAME}</div>)
        // } else {
        //     console.error('Unknown option:', items.name)
        // }
    }

    // Filter settingsList based on search query
    const filteredSettings = settingsList.filter(item =>
        item.title.toLowerCase().includes(search.toLowerCase())
    )

    const handleSearch = (event) => {
        setSearch(event)
    }

    const handleSelectNav = (data) => {
        if (data?.navLink === 'help-center') {
            setselectedNav(data?.navLink)
            navigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.HELP_CENTER.URI, MainContainerEntity.MENU_TYPE_HELP_CENTER)
        } else {
            setselectedNav(data?.navLink)
        }
    }
    const isAdmin = JSON.parse(localStorage.getItem('isAdmin'))
    const ref = useRef(null)
    return (
        <Fragment>
            <div className="p-7 w-full h-full flex flex-row !overflow-auto bg-[#fff]">
                <div className='w-[30%] h-[100%] flex flex-col gap-4'>
                    <div className='w-[100%] flex flex-col flex-grow justify-center items-center'>
                        <CustomSearchField
                            className="w-[100%] h-[100%] text-grey"
                            value={search}
                            setSearch={setSearch}
                            onValueChange={handleSearch}
                            // searchData={filteredSettings}
                            setSelectedData={handleSelectNav}
                        />
                    </div>
                    <div className='w-[100%] h-[90%]  !overflow-auto'>
                        {filteredSettings?.filter((filterData) => filterData?.visible)?.map((mapDt, mapIndex) => (
                            <>
                                {mapDt.title === 'User Management' && !isAdmin
                                    ? null
                                    : <div key={mapIndex} onClick={() => { handleSelectNav(mapDt) }} className={cn(selectedNav === mapDt?.navLink && 'bg-primary-foreground', 'flex flex-row py-[16px] mb-[10px] pl-[18px] cursor-pointer justify-between items-center rounded-[5px]')}>
                                        <div className={cn(selectedNav === mapDt?.navLink ? 'text-primary' : 'text-muted', 'flex flex-row items-center w-[90%]')}>
                                            {mapDt?.icon}
                                            <p className={cn(selectedNav === mapDt?.navLink ? 'text-primary' : 'text-muted', 'text-setting')}>{mapDt?.title}</p>
                                        </div>
                                        <div className={cn(selectedNav === mapDt?.navLink ? 'text-primary' : 'text-muted', 'flex flex-row items-center justify-center w-[10%]')} >
                                            {mapDt?.rightNavIcon}
                                        </div>
                                    </div>}
                            </>
                        )
                        )}
                    </div>
                </div>
                <div className='w-[70%] h-[100%]'>
                    {selectedNav === 'profile' && <ProfileContainer />}
                    {selectedNav === 'general' && <General />}
                    {selectedNav === 'userManagement' && <div className='w-[100%] pt-2 px-[20px] h-[100%]'>
                        <p className="h-[7%] text-h0 px-4 pb-3 font-bold flex flex-col justify-center" style={{ color: 'hsl(var(--primary))' }}>{'User Management'}</p>
                        {userManagementData?.map((mapDt, mapIndex) =>
                            <div onClick={() => handleSettingSubOptions(mapDt)} key={mapIndex} className='border-2 border-primary-foreground rounded-[8px] cursor-pointer mb-[20px] w-full flex flex-row justify-between items-center p-[20px]'>
                                <p className={cn('!text-primary text-h4-selected')}>{mapDt?.title}</p>
                                {mapDt?.rightNavIcon}
                            </div>)}
                    </div>}
                    {
                        selectedNav === 'configuration' && <ConfigurationsContainer ref={ref} />
                    }
                </div>
            </div>
        </Fragment>
    )
}

export default SettingsContainer
